import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import activityTracker from '../utils/activityTracker';

// Drives the activity tracker from auth + route state. Renders nothing.
// Must live inside <BrowserRouter> (uses useLocation) and the AuthProvider.
const ActivityTracker = () => {
  const { authState } = useAuth();
  const { isAuthenticated } = authState;
  const location = useLocation();

  // Start/stop the tracker with the auth session.
  useEffect(() => {
    if (!isAuthenticated) return undefined;
    activityTracker.start();
    return () => activityTracker.stop();
  }, [isAuthenticated]);

  // Record a page_view whenever the route changes (while logged in).
  useEffect(() => {
    if (!isAuthenticated) return;
    activityTracker.trackPageView(location.pathname);
  }, [isAuthenticated, location.pathname]);

  return null;
};

export default ActivityTracker;
